module.exports = __webpack_public_path__ + "img/jpg.63f035a9.png";